import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import DropdownMenu from "@/v2-ui/dropdownMenu"

export type ActionMenuLabelProps = ComponentProps<typeof DropdownMenu.Label>

function ActionMenuLabel(props: ActionMenuLabelProps) {
  const { className, ...rest } = props
  return (
    <DropdownMenu.Label
      className={cn("action-menu-label", className)}
      {...rest}
    />
  )
}

export default ActionMenuLabel
